import axios from 'axios';

const instance = axios.create({
  baseURL: HTTP_API  
})

instance.defaults.headers.get['Accepts'] = 'application/json';


export default instance;


// WEBPACK FOOTER //
// ./src/scripts/server.js